import { utcDate } from 'owa-datetime';

/**
 * Tests whether or not the string can make a valid owaDate object with utcDate
 * @param dateTimeString the datetime string to be tested
 */
export default function tryCreateUtcDate(
    dateTimeString: string,
    errorHandler?: (e: Error) => void
): boolean {
    try {
        return !!utcDate(dateTimeString);
    } catch (e) {
        errorHandler && errorHandler(e);
    }
    return false;
}
